module.exports = __webpack_public_path__ + "static/media/download.fc5b67ea.svg";